import {Consommation} from '../consommation/consommation.interface';
import {LineFolders} from './lineFolder.interface';

export namespace Folders {

  export interface FolderInterface extends Consommation.ConsommationInterface {
    statutAdministratif?: Folders.StatusAdministratifEnum;
    lignes?: Array<LineFolders.LineFolderInterface>;
  }

  export type StatusAdministratifEnum = 'ENC' | 'ATT' | 'VAL' | 'REF' | 'FAC' | 'PAYPAR' | 'PAY' | 'SUPP';

  export const StatusAdministratifEnum = {
    EnCours: 'ENC' as StatusAdministratifEnum,
    Attente: 'ATT' as StatusAdministratifEnum,
    Valide: 'VAL' as StatusAdministratifEnum,
    Refuse: 'REF' as StatusAdministratifEnum,
    Facture: 'FAC' as StatusAdministratifEnum,
    PayerPartiellement: 'PAYPAR' as StatusAdministratifEnum,
    Paye: 'PAY' as StatusAdministratifEnum,
    Supprime: 'SUPP' as StatusAdministratifEnum
  };

  /**
   * According to the states the reimbursement is editable or not
   * @param {FolderType.FolderInterface} folder
   * @returns {boolean}
   */
  export function isEditable(folder: FolderInterface): boolean {
    return [
      Folders.StatusAdministratifEnum.Attente,
      Folders.StatusAdministratifEnum.Valide,
      Folders.StatusAdministratifEnum.EnCours
    ].indexOf(folder.statutAdministratif) !== -1;
  }
}



// WEBPACK FOOTER //
// ./src/shared/models/folder/folder.interface.ts